export enum ComponentLoadState {
    Pending,
    FetchingData,
    PreloadingAssets,
    Loaded,
    Errored,
}
